import { render, staticRenderFns } from "./BtnLoadingProgress.vue?vue&type=template&id=1f159468"
import script from "./BtnLoadingProgress.vue?vue&type=script&lang=js"
export * from "./BtnLoadingProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports